import React from 'react';
import Confetti from 'react-confetti';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar } = FiIcons;

export default function Step5Handoff() {
  const width = window.innerWidth;
  const height = window.innerHeight;

  return (
    <div className="relative">
      <Confetti width={width} height={height} recycle={false} numberOfPieces={500} />
      
      <motion.div 
        initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className="card-premium text-center relative z-10 overflow-hidden"
      >
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-blue-400 via-indigo-500 to-purple-500"></div>
        
        <div className="bg-blue-50 w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6">
          <SafeIcon icon={FiStar} className="w-12 h-12 text-blue-600" />
        </div>

        <h2 className="text-4xl font-extrabold text-slate-900 mb-4">Funding Secured!</h2>
        <p className="text-xl text-slate-600 mb-8 max-w-md mx-auto">
          We've initiated the payoff with your carrier. You are now free to claim your new $15/mo plan and start saving today.
        </p>

        <a 
          href="https://www.mintmobile.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center w-full px-8 py-5 text-xl font-bold rounded-xl text-white bg-indigo-600 hover:bg-indigo-700 transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-1"
        >
          Activate Mint Mobile Now
        </a>
        
        <p className="mt-4 text-sm text-slate-400">
          You will be securely redirected to our partner site to finish your switch.
        </p>
      </motion.div>
    </div>
  );
}